import { CanActivateFn } from '@angular/router';
import { lastValueFrom, Observable } from 'rxjs';
import { inject, Injector, runInInjectionContext } from '@angular/core';

export const conjunctionGuard: CanActivateFn = async (route, state) => {

  const injector = inject(Injector);
  const guards: CanActivateFn[] = route.data?.guards || [];

  for (const guard of guards) {

    // Guards have to run in an injection context to be able to inject services
    let canActivate = runInInjectionContext(injector, () => guard(route, state));

    if(canActivate instanceof Promise) {
      canActivate = await canActivate;
    } else if (canActivate instanceof Observable) {
      canActivate = await lastValueFrom(canActivate);
    }

    if (canActivate !== true) {
      return false;
    }
  }

  return true;
};
